var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRaft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "40px",
    height: "40px",
    viewBox: "0 0 64 64",
    enableBackground: "new 0 0 64 64",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1E81F7",
    d: "M32,16c2.961,0,5.699,0.859,8.078,2.262l11.52-11.52C46.18,2.531,39.391,0,32,0 c-7.395,0-14.18,2.531-19.602,6.742l11.52,11.523C26.297,16.859,29.039,16,32,16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E81F7",
    d: "M57.262,12.406L45.738,23.922C47.141,26.301,48,29.039,48,32s-0.859,5.703-2.262,8.078l11.52,11.52 C61.469,46.18,64,39.391,64,32S61.469,17.82,57.262,12.406z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E81F7",
    d: "M40.078,45.738C37.699,47.141,34.961,48,32,48s-5.699-0.859-8.078-2.262l-11.52,11.52 C17.82,61.469,24.609,64,32,64s14.18-2.531,19.598-6.742L40.078,45.738z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1E81F7",
    d: "M16,32c0-2.961,0.859-5.699,2.262-8.078l-11.52-11.52C2.531,17.82,0,24.609,0,32 c0,7.395,2.531,14.18,6.742,19.602l11.52-11.523C16.859,37.703,16,34.961,16,32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRaft);
export default __webpack_public_path__ + "static/media/raft.5ace8c56e1a5b1f84ebaa00d5f95081a.svg";
export { ForwardRef as ReactComponent };